// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class AuthService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	login(username, password, callback) {
		const url = "/ecosystem/api/auth/token";
		const body = JSON.stringify({
			username: username,
			password: password
		});
		this._restClient.exec_post(url, body, function (err, result) {
			if (err) {
				callback(err, null);
			}
			if (callback) {
				callback(null, result);
			}
		});
	}

	loginWorkstation(username, password, workstationId, callback) {
		const wsTokenUrl = "/ecosystem/api/auth/workstationToken";
		const authTokenUrl = "/ecosystem/api/auth/token";
		const wsTokenBody = JSON.stringify({
			username: username,
			password,
			workstationId
		});
		this._restClient.exec_post(wsTokenUrl, wsTokenBody, (err, workstationResult) => {
			if (err) {
				callback(err, null);
			}
			let finalResult = { workstationResult };

			const authTokenBody = JSON.stringify({
				workstationToken: workstationResult.workstation_token
			});

			this._restClient.exec_post(authTokenUrl, authTokenBody, (err, result) => {
				finalResult = { ...finalResult, ...result };
				if (err) {
					callback(err, null);
				}
				if (callback) {
					callback(null, finalResult);
				}
			});
		});
	}

	switchUser(username, password, callback) {
		const url = "/ecosystem/api/auth/switchUser";
		const body = JSON.stringify({
			username: username,
			password: password
		});
		this._restClient.exec_post(url, body, function (err, result) {
			if (err) {
				callback(err, null);
			} else if (callback) {
				callback(null, result);
			}
		});
	}

	logout(callback) {
		const url = "/ecosystem/api/logout";
		this._restClient.exec_delete(url, function (err) {
			if (err) {
				callback(err, null);
			}
			if (callback) {
				callback(null, { success: true });
			}
		});
	}

	logoutByUserId(userId, callback) {
		const url = `/ecosystem/api/logout/${userId}`;
		this._restClient.exec_delete(url, function (err) {
			if (err) {
				callback(err, null);
			}
			if (callback) {
				callback(null, { success: true });
			}
		});
	}

	checkLogout(callback) {
		const url = "/ecosystem/api/auth/checkLogout";
		this._restClient.exec_get(url, callback);
	}

	async getLoggedInUser(callback) {
		const url = "/ecosystem/api/loggedInUser";
		this._restClient.exec_get(url, callback);
	}

	requestReset(email, callback) {
		const url = `/ecosystem/api/auth/${email}/forgot`;
		this._restClient.exec_get(url, callback);
	}

	verifyReset(token, callback) {
		const url = `/ecosystem/api/auth/reset/${token}`;
		this._restClient.exec_get(url, callback);
	}

	verifySetInitialPassword(token, callback) {
		const url = `/ecosystem/api/auth/initial/${token}`;
		this._restClient.exec_get(url, callback);
	}

	setInitialPassword(password, token, callback) {
		const body = JSON.stringify({
			password: password
		});
		const url = `/ecosystem/api/auth/initial/${token}`;
		this._restClient.exec_put(url, body, callback);
	}

	resetPassword(password, token, callback) {
		const body = JSON.stringify({
			password: password
		});
		const url = `/ecosystem/api/auth/reset/${token}`;
		this._restClient.exec_put(url, body, callback);
	}

	// LDAP

	/**
	 * Query an LDAP or Active Directory system via connection information and return a list of users for a particular group,
	 *   returning the correct information based on an initial query or an update query
	 * @param {string} host -- LDAP/AD hostname
	 * @param {string} port -- LDAP/AD port
	 * @param {string} username -- LDAP/AD login username
	 * @param {string} password -- LDAP/AD password
	 * @param {string} groupName -- LDAP/AD group name or distinguished name (dn)
	 * @param {string} baseDN -- LDAP/AD baseDN (ex "dc=myCoolSystem,dc=com")
	 * @param {string} authType -- "system", "ldap", or "active-directory"
	 * @param {boolean} update -- update LDAP/AD data or query it for the first time
	 * @param {function} callback
	 */
	testAuthConnection(host, port, username, password, groupName, baseDN, authType, update, callback) {
		const body = JSON.stringify({
			host,
			port,
			username,
			password,
			groupName,
			baseDN,
			authType,
			update
		});
		const url = "/ecosystem/api/auth/connection";
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Add an authProvider entry for the organization and attempt add users to DB
	 * @param {string} orgId -- Organization id
	 * @param {object} connectionData -- hostname, port, username, password, groupName, baseDN, authType
	 * @param {array} users -- list of users to create
	 * @param {function} callback
	 */
	createAuthenticationInfo(orgId, connectionData, users, callback) {
		const url = "/ecosystem/api/auth/method";
		const body = JSON.stringify({
			orgId,
			connectionData,
			users
		});

		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update an authProvider entry for the organization and attempt to update/create users based on current AD or LDAP
	 * @param {string} orgId -- Organization id
	 * @param {object} connectionData -- hostname, port, username, password, groupName, baseDN, authType
	 * @param {array} users -- list of users to create
	 * @param {string} authId -- Org's current authProvider id
	 * @param {function} callback
	 */
	updateAuthenticationInfo(orgId, connectionData, users, authId, callback) {
		const url = "/ecosystem/api/auth/method/update";
		const body = JSON.stringify({
			orgId,
			connectionData,
			users,
			authId
		});

		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Set an action to be called when a session has ended
	 * @param {function} handler - action called when session ends;
	 */
	addSessionEndHandler(handler) {
		this._rc._sessionEndHandler = handler;
	}
}
